import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-24" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Database ")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "flex flex--justify-center" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.loading)
          ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode($setup["TabNavigationComponent"], {
                tabs: $setup.tabs,
                "active-tab": $setup.active_tab,
                disabled: $setup.loading_results,
                onSetTab: $setup.setTab
              }, null, 8 /* PROPS */, ["tabs", "active-tab", "disabled"]),
              _createVNode($setup["DatabaseFiltersComponent"]),
              _createVNode($setup["DatabaseGridComponent"], {
                options: $setup.database_options,
                loading: $setup.loading_results,
                onFetchMoreResults: $setup.fetchMoreOptions,
                onUpdateDatabaseLikes: $setup.updateDatabaseLikes,
                onUpdateDatabaseTags: $setup.updateDatabaseTags
              }, null, 8 /* PROPS */, ["options", "loading"]),
              _createElementVNode("div", _hoisted_4, [
                ($setup.database_options.length && $setup.database_options.length < $setup.pagination.total_count)
                  ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], {
                      key: 0,
                      ref: "load_more_trigger",
                      small: true
                    }, null, 512 /* NEED_PATCH */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}